<template>
  <v-app id="login" class="primary general-form-wrapper">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-form id="login_form" method="post" v-model="form.valid" :action="form.action" v-on:success="login_success" ref="login_form">
              <v-card class="elevation-1 pa-3">

                <v-alert
                        :value="errors.general!==''"
                        type="error"
                >
                  {{errors.general}}
                </v-alert>

                <v-card-text>
                  <div class="layout column align-center">
                    <!--<img src="/static/m.png" alt="Vue Material Admin" width="120" height="120">-->
                    <h1 class="flex my-4 primary--text">{{$t("login.header")}} - {{ $t("app.name") }}</h1>
                  </div>
                  <input v-if="$route.meta.public_login" type="hidden" name="organizer" value="free">
                  <input type="hidden" name="is_public_login" :value="$route.meta.public_login">
                  <!-- use placeholder to show the input label to handle the autofill issue of chrome -->
                  <!-- reference: https://github.com/vuetifyjs/vuetify/issues/3679 -->
                  <v-text-field
                          v-if="!$route.meta.public_login"
                          append-icon="work"
                          name="organizer"
                          :error-messages="errors.organizer"
                          :rules="[rules.required]"
                          :placeholder="$t('login.organizer_code')"
                          ref="organizer"
                          type="text">
                  </v-text-field>
                  <v-text-field
                          append-icon="email"
                          ref="email"
                          name="email"
                          :placeholder="$t('user.email')"
                          type="text"
                          :error-messages="errors.email"
                          :rules="[rules.required, rules.email]">
                  </v-text-field>
                  <v-text-field
                          append-icon="lock"
                          ref="password"
                          name="password"
                          :placeholder="$t('login.password')"
                          type="password"
                          :error-messages="errors.password"
                          :rules="[rules.required]">
                  </v-text-field>
                    <p class="text-xs-right">
                        <a @click="toForgetPassword">{{$t('login.forget_password')}}?</a>
                    </p>
                </v-card-text>
                <v-card-actions>
<!--                  <v-btn v-if="$route.meta.public_login" :to="{ name: 'login'}" replace type="button">{{$t('login.pro_version')}}</v-btn>-->
<!--                  <v-btn v-if="!$route.meta.public_login" :to="{ name: 'public_login'}" replace type="button">{{$t('login.public_login')}}</v-btn>-->
<!--                  <v-spacer></v-spacer>-->
                  <v-btn block color="primary"
                         type="submit"
                         ref="submit"
                         :loading="form.loading"
                  >{{$t('login.button')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
            <div class="text-xs-center">
              <v-btn flat color="primary" :to="{name: 'signup'}">{{$t('login.signup')}}</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
      <app-footer></app-footer>
  </v-app>
</template>

<script>
    import FormHandling from '~/utils/data/form-handling'
    import {UrlServices} from '~/utils/url-manager'
    import AppFooter from "~/components/AppFooter";

    export default {
        components: {AppFooter},
        data() {
            return {
                form: {
                    action: UrlServices.createUrl({'name': 'api_login'}),
                    loading: false,
                    valid: false
                },
                rules: {
                    required: value => !!value || this.$t('form.field_required'),
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || this.$t('login.email_invalid')
                    }
                },
                errors: {
                    general: "",
                    organizer: "",
                    email: "",
                    password: ""
                }
            }
        },
        methods: {
            login () {
                this.form.loading = true;
                setTimeout(() => {
                    this.$router.push('/dashboard');
                }, 1000);
            },
            login_success(data) {
                window.getApp.$emit('APP_LOGIN_SUCCESS');
            },
            toForgetPassword() {
                this.$router.push({ name: 'forget_password'});
            }
        },
        mounted: function() {
            if(this.$route.meta.public_login){
                this.$store.dispatch('setLoginType', 'public').then();
            }else{
                this.$store.dispatch('setLoginType', 'organizer').then();
            }
            new FormHandling(this, "login_form");
        }

    };
</script>
<style scoped lang="css">

</style>
